<script setup>
import { defineProps, defineEmits } from "vue";

const props = defineProps({
  title: String,
  type: String,
  placeholder: String,
  modelValue: [String, Number],
});

defineEmits(["update:modelValue"]);
</script>

<template>
  <div class="col-sm-4 mb-3">
    <span class="text-sm">
      <b>{{ props.title }}:</b>
    </span>
    <input
      :type="props.type"
      :placeholder="placeholder ?? 0"
      :value="modelValue"
      class="form-control"
      @input="$emit('update:modelValue', $event.target.value)"
    />
  </div>
</template>
